angular.module("app")

	.directive("ajaxLoader", ["$http", "ngProgress", "ENV", function ($http, ngProgress, ENV) {
		return {
			restrict: "E,A",
			link: function (scope, elm) {

				ngProgress.color("#E96211");
				ngProgress.height("4px");

				scope.isLoading = function () {
					//return $http.pendingRequests.length > 0;
					const pendingRequests = $http.pendingRequests;
					if (pendingRequests.length > 0) {
						for (let index in pendingRequests) {
							const url = pendingRequests[index].url;
							if (url !== undefined) {

								const endsWithTbl = [".html", "action_report.json", "okinaJobStatus", "/admin/users/school-iti-settings"];
								for (const p of endsWithTbl) {
									if (url.endsWith(p)) {
										return false;
									}
								}

								const containsTbl = ["/refresh-status/", ENV.API_UPDATE_OKINA_APP, "/events/1.0/", "/exports", "/export", "/clients", "/generate-geojson-all-journey-patterns"];
								for (const p of containsTbl) {
									if (url.includes(p)) {
										return false;
									}
								}

								return true;
							}
						}
					} else {
						return false;
					}
					return false;
				};

				scope.$watch(scope.isLoading, function (v) {
					if (v) {
						//elm.show();
						ngProgress.start();
					} else {
						//elm.hide();
						ngProgress.complete();
					}
				});
			}
		};

	}]);
